import axios from "axios";

const API = axios.create({
  baseURL: "https://kingshoppy-backend.onrender.com/api",
});

export default API;
